export default "__VITE_ASSET__CblO_bxf__"